import { c as _c } from "react/compiler-runtime";
import { FormControl, FormLabel } from '@mui/material';
import type { Account } from '@repo/api-gw-sdk';
import { useState } from 'react';
import type { BackupVault } from '@/data/vaults/backupVault';
import { SelectVaultBucketPanel } from './selectVaultBucketPanel';
import { ChangeableTextField } from '../text/changeableTextField';
export const VaultAccountBucketSelector = t0 => {
  const $ = _c(13);
  const {
    data,
    setData,
    vaultAccounts
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FormLabel>{"Vault account and bucket"}</FormLabel>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = data.vaultAttributes.aws?.bucketName;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setOpen(true);
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2) {
    t4 = <ChangeableTextField value={t2} onClick={t3} placeholder="None selected" />;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpen(false);
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== data || $[6] !== open || $[7] !== setData || $[8] !== vaultAccounts) {
    t6 = <SelectVaultBucketPanel open={open} onClose={t5} disabled={false} data={data} setData={setData} vaultAccounts={vaultAccounts} />;
    $[5] = data;
    $[6] = open;
    $[7] = setData;
    $[8] = vaultAccounts;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <FormControl size="small" className="flex-1">{t1}{t4}{t6}</FormControl>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};